<template>
  <div class="comments">
    <div class="col">
      <!--v-for="comment in comments" :comment="comment"-->
      <ReComment></ReComment>
    </div>
  </div>
</template>

<script>
import ReComment from "src/our_components/ReComment.vue";

export default {
  name: "ReCommentsAll",
  components: {
    ReComment
  },
  props: {
    counter: String,
    findId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      ver: 1,
      comments: []
    };
  },
  computed: {},
  methods: {}
};
</script>
<style scoped>
.comments {
  display: flex;
  flex-direction: column;
}
.comments .col {
  padding: 0;
}
</style>
